/**
 * Business loan identifier for display (list, export, modal).
 * Optional fallbackId (e.g. route sale id) when sale is not loaded or has no loan_identifier.
 */
export function getSaleLoanIdentifierDisplay(sale, fallbackId) {
  const raw = sale?.loan_identifier ?? sale?.loan?.loan_identifier;
  if (raw != null && String(raw).trim() !== '') {
    return String(raw).trim();
  }
  const fb = fallbackId != null ? fallbackId : sale?.id;
  return fb != null ? String(fb) : '';
}
